(() => {
  const videos = document.querySelectorAll('video[data-deferred-video]');
  if (!videos.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const loadVideo = (video) => {
    if (video.dataset.loaded || !video.dataset.src) return;

    const source = document.createElement('source');
    source.src = video.dataset.src;
    source.type = video.dataset.type || 'video/mp4';
    video.appendChild(source);
    video.dataset.loaded = 'true';
    video.load();

    const playPromise = video.play();
    if (playPromise) playPromise.catch(() => {});
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach(loadVideo);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      loadVideo(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '300px 0px' });

  videos.forEach((video) => observer.observe(video));
})();
